// extracted by mini-css-extract-plugin
module.exports = {"documentationCta":"_1S8XC"};